import { useState } from "react";
import { toast } from "sonner";
import { Combine } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const UnisciStudi = ({ onDone }) => {
  const [groups, setGroups] = useState(null);
  const [keep, setKeep] = useState({});
  const [busy, setBusy] = useState(false);
  const open = async () => {
    const { data } = await api.get("/admin/studios-doppi");
    setKeep(Object.fromEntries(data.map((g) => [g.piva, [...g.studi].sort((a, b) => b.companies - a.companies || b.users - a.users || String(a.created_at).localeCompare(String(b.created_at)))[0].id])));
    setGroups(data);
  };
  const unisci = async (g) => {
    const k = g.studi.find((s) => s.id === keep[g.piva]);
    if (!window.confirm(`Unire ${g.studi.length - 1} studio/i doppio/i in "${k.denominazione}"? Aziende e accessi passano su questo studio e i doppioni vengono eliminati.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/studios/${keep[g.piva]}/unisci`, { ids: g.studi.map((s) => s.id) });
      toast.success(`Studi uniti: ${data.aziende} aziende e ${data.utenti} accessi spostati sullo studio tenuto`);
      setGroups(groups.filter((x) => x.piva !== g.piva));
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="w-full bg-white" data-testid="unisci-studi-button" onClick={open}><Combine className="mr-2 h-4 w-4" />Unisci studi doppi</Button>
      <Dialog open={!!groups} onOpenChange={(o) => !o && setGroups(null)}>
        <DialogContent data-testid="unisci-studi-dialog" className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Unisci studi doppi</DialogTitle>
            <DialogDescription>Studi con la stessa partita IVA. Scegli quale tenere: aziende clienti, utenti e accessi degli altri passano su quello, poi i doppioni vengono eliminati.</DialogDescription>
          </DialogHeader>
          {groups?.length === 0 && <p data-testid="unisci-studi-empty" className="text-sm text-slate-600">Nessuno studio doppio: ogni partita IVA ha un solo studio.</p>}
          <div className="max-h-[60vh] space-y-4 overflow-y-auto">
            {(groups || []).map((g) => (
              <div key={g.piva} data-testid={`doppi-${g.piva}`} className="rounded-lg border border-slate-200 p-3">
                <div className="mb-2 font-mono text-xs text-slate-500">P.IVA {g.piva}</div>
                {g.studi.map((s) => (
                  <label key={s.id} className="flex cursor-pointer items-center gap-2 py-1 text-sm">
                    <input type="radio" name={g.piva} data-testid={`doppi-keep-${s.id}`} checked={keep[g.piva] === s.id} onChange={() => setKeep({ ...keep, [g.piva]: s.id })} />
                    <span className="font-medium">{s.denominazione}</span>
                    <span className="text-xs text-slate-500">· {s.companies} aziende · {s.users} accessi{s.own_company_id ? " · anche azienda" : ""}</span>
                    {keep[g.piva] === s.id && <span className="rounded bg-emerald-100 px-1.5 text-[10px] font-semibold text-emerald-800">DA TENERE</span>}
                  </label>
                ))}
                <Button size="sm" className="mt-2 bg-sky-600 hover:bg-sky-700" disabled={busy} data-testid={`doppi-unisci-${g.piva}`} onClick={() => unisci(g)}>Unisci in quello da tenere</Button>
              </div>
            ))}
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setGroups(null)}>Chiudi</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
